export default __webpack_public_path__ + "static/media/emptyWishList.78d4b4ff.png";